"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["className", "defaultValue", "onChange"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputJson/index.js";
var noop = function noop() {};
var defaultProps = {
  type: 'text',
  onChange: noop
};
function InputJson(_ref) {
  var className = _ref.className,
    defaultValue = _ref.defaultValue,
    onChange = _ref.onChange,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  function onInput(event) {
    var value = event.target.value;
    try {
      event.target.setCustomValidity("");
      var parse = JSON.parse(value);
      onChange(parse);
    } catch (error) {
      event.target.setCustomValidity(error.message);
    }
  }
  return /*#__PURE__*/_react["default"].createElement("textarea", Object.assign({
    defaultValue: JSON.stringify(defaultValue, null, 4) || '',
    className: (0, _classNames["default"])('form-control', className),
    onInput: onInput
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 9
    }
  }));
}
InputJson.defaultProps = defaultProps;
var _default = InputJson;
exports["default"] = _default;